"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9955],{

/***/ 36538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CardCourse; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var lib_date__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(59647);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67832);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Icon_IconStar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28939);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61097);
/* harmony import */ var lib_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99601);
/* harmony import */ var lib_device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59799);
/* harmony import */ var components_Chip_LogoChip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90768);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51776);
/* harmony import */ var lib_amplitude__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41272);
/* harmony import */ var components_Chip_Chip__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5867);
/* harmony import */ var lib_host__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35304);
/* harmony import */ var components_Icon_IconPlusCircle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(38445);
/* harmony import */ var components_Icon_IconCheckCircle__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4110);
/* harmony import */ var modules_Business_Selection_cartStore__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13084);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86880);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(56562);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var components_Icon_IconPlayCircle__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14016);




















//@ts-ignore
const CardCourse = ({ isLayoutNew =false , className ="" , isUncheck =false , isHide =false , ...props })=>{
    const isSubdomainTenant = (0,lib_host__WEBPACK_IMPORTED_MODULE_11__/* .useIsSubdomain */ .Do)();
    const isDesktop = (0,lib_device__WEBPACK_IMPORTED_MODULE_5__/* .useIsDesktop */ .Ce)();
    const [timeout, setModalTimeout] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(null);
    const [checkedCard, setCheckedCard] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([]);
    const isTenatURL = (0,lib_host__WEBPACK_IMPORTED_MODULE_11__/* .useIsTenant */ .we)();
    const isB2B = (0,lib_host__WEBPACK_IMPORTED_MODULE_11__/* .useIsTenant */ .we)() || (0,lib_host__WEBPACK_IMPORTED_MODULE_11__/* .useIsSubdomain */ .Do)();
    const isBusiness = !isB2B;
    const updateCart = (0,modules_Business_Selection_cartStore__WEBPACK_IMPORTED_MODULE_14__/* .useCartStore */ .x)((state)=>state.updateCart);
    let institutionImage = //@ts-ignore
    props?.institution?.image_url ? props?.institution?.image_url : typeof props?.institution == "string" && //@ts-ignore
    props?.institution?.split("||").length > 1 && //@ts-ignore
    props?.institution?.split("||")[1].includes("https") ? props?.institution?.split("||")[1] : props?.institution && typeof props?.institution == "object" ? props?.institution?.image_url : null;
    let institutionName = //@ts-ignore
    props.institution?.name || props.institution?.split("||")[0] || "";
    const classHeight = className == "card-my-class" ? "112px" : className == "card-default" ? "164px" : "171px";
    const wCustom = props?.isHorizontal ? 287 : 328;
    const hCustom = props?.isHorizontal ? 164 : 228;
    const hasUserPaid = props.is_paid;
    const isCourseFree = props.original_price === 0 || props.discounted_price === 0;
    const isCourseFinished = props.enrollment_progress?.finished === props.enrollment_progress?.total;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const events = {
        event: "course_hover_a",
        property: {
            course_name: props?.name ?? "",
            course_slug: props?.slug ?? "",
            section_name: props?.sectionName ?? "",
            institution_name: //@ts-ignore
            props?.institution_name ?? props.institution?.name ?? "",
            index: props?.index ?? 0,
            page: router.pathname
        }
    };
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("common");
    if (isLayoutNew) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: `w-full overflow-hidden cursor-pointer ${className == "card-my-class" ? "rounded-4" : className == "card-hidden" ? "!opacity-0" : "rounded-8"}`,
            onClick: ()=>{
                //@ts-ignore
                if (props.onSelect) {
                    //@ts-ignore
                    // props.onSelect();
                    updateCart(props);
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "group relative w-full h-full flex flex-col flex-wrap",
                onMouseEnter: isBusiness ? undefined : ()=>{
                    timeout && clearTimeout(timeout);
                    setModalTimeout(setTimeout(()=>{
                        (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_9__/* .trackEventGTM */ .hk)({
                            ...events
                        });
                        (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_9__/* .trackEventGA */ .w7)({
                            ...events
                        });
                    }, 3000));
                },
                onMouseLeave: isBusiness ? undefined : ()=>{
                    timeout && clearTimeout(timeout);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative group-hover:h-fit",
                        children: [
                            props.isHorizontal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: props.image_cover_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    alt: props.name,
                                    src: props.image_cover_url,
                                    width: wCustom,
                                    height: hCustom,
                                    "data-testid": "card-featured_cover",
                                    className: "object-cover w-full h-full object-center",
                                    style: {
                                        borderRadius: className == "card-my-class" ? "4px 4px 0 0" : "8px 8px 0 0"
                                    }
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "bg-neutral-20" + (props?.isHorizontal ? `${className == "card-my-class" ? " h-[112px]" : ` ${isUncheck ? "h-[156px]" : "h-[164px] xl-max:h-[100px]"}`} w-full` : " h-[228px] w-full"),
                                    style: {
                                        borderRadius: className == "card-my-class" ? "4px 4px 0 0" : "8px 8px 0 0"
                                    }
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: props.image_cover_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    alt: props.name,
                                    src: props.image_cover_url,
                                    className: "object-cover w-full object-center" + ` h-[${isDesktop ? "171" : classHeight}px]`,
                                    style: {
                                        borderRadius: className == "card-my-class" ? "4px 4px 0 0" : "8px 8px 0 0"
                                    }
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "bg-neutral-20 w-full h-[171px] xl-max:h-[144px]",
                                    style: {
                                        borderRadius: className == "card-my-class" ? "4px 4px 0 0" : "8px 8px 0 0"
                                    }
                                })
                            }),
                            !isBusiness && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute top-0 w-full h-full group-hover:hidden",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-full flex justify-center items-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconPlayCircle__WEBPACK_IMPORTED_MODULE_17__/* .IconPlayCircle */ .U, {
                                        size: 45,
                                        classes: "m-auto",
                                        isBgCustomized: true
                                    })
                                })
                            }),
                            isBusiness && router.pathname == "/pilih-kursus" && !isUncheck && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute top-0 w-full h-full flex justify-end items-start p-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconPlusCircle__WEBPACK_IMPORTED_MODULE_12__/* .IconPlusCircle */ .O, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[116px] bg-purple-70",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: `w-full h-full group-hover:absolute group-hover:bottom-0 group-hover:flex group-hover:flex-col group-hover:justify-between`,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-[-webkit-fill-available] hidden justify-center items-center group-hover:flex",
                                    children: !isBusiness && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: "/images/icon-play-grey.svg",
                                        alt: "playGrey",
                                        width: 45,
                                        height: 45
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: `gap-8 bg-purple-70 h-full text-white py-14 px-16 items-center transition-height duration-500 ease-in-out absolute`,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col justify-between h-full " + (className == "card-institutions" ? "gap-4" : "gap-8"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "text-b1 font-medium max-w-full line-clamp-2 text-white text-left",
                                                    children: props.name
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex gap-8 items-center",
                                                    children: [
                                                        institutionImage && // <LogoChip image_url={institutionImage} size={36} />
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Chip_LogoChip__WEBPACK_IMPORTED_MODULE_6__/* .LogoChip */ .E, {
                                                            image_url: institutionImage,
                                                            size: 40,
                                                            padding: 4,
                                                            useResizeImage: true
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "grid gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "text-c1 font-light max-w-full truncate text-left",
                                                                    children: institutionName
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "flex gap-8 justify-start items-center text-c1 font-light",
                                                                    children: [
                                                                        typeof props?.review_summary?.star_avg === "number" && //@ts-ignore
                                                                        props?.review_summary?.star_avg !== 0 && !isB2B ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    className: "flex items-center justify-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconStar__WEBPACK_IMPORTED_MODULE_2__/* .IconStar */ .G, {
                                                                                            size: 14,
                                                                                            fill: true,
                                                                                            color: "#EFB443"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                            className: "ml-2 text-c1",
                                                                                            children: (0,lib_helper__WEBPACK_IMPORTED_MODULE_4__/* .formatRating */ .A6)(//@ts-ignore
                                                                                            props?.review_summary?.star_avg.toFixed(1))
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                "|"
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                                                        props.total_learners !== 0 && !isB2B && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            children: `${(0,lib_helper__WEBPACK_IMPORTED_MODULE_4__/* .numberWithCommas */ .x6)(props.total_learners)} ${t("pelajar").toLowerCase()}`
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "hidden group-hover:inline-block mt-2",
                                                    children: isBusiness ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_16___default()), {
                                                        className: "hidden w-full group-hover:inline-block mt-2",
                                                        // @ts-ignore
                                                        href: `https://www.gokampus.com/course/${props.slug}`,
                                                        passHref: true,
                                                        // target="__blank"
                                                        rel: "noopener noreferrer",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                            variant: "white_transparant",
                                                            className: "w-full",
                                                            children: "Lihat Kursus"
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: props.tags.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    className: "text-c1 font-medium mb-8 text-left",
                                                                    children: t("skills")
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "flex flex-wrap gap-12 items-center",
                                                                    children: [
                                                                        props?.tags?.slice(0, 3).map((tag, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Chip_Chip__WEBPACK_IMPORTED_MODULE_10__/* .Chip */ .A, {
                                                                                className: "text-violet_main_to_dark_purple_surface",
                                                                                children: tag || tag.toString()
                                                                            }, i + tag)),
                                                                        props?.tags.length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "text-white text-c1 font-medium",
                                                                            children: [
                                                                                "+",
                                                                                props.skills.length - 3,
                                                                                " Tag lainnya"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }) : null
                                                    })
                                                })
                                            ]
                                        }),
                                        className == "card-my-class" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-b2 pt-4",
                                            children: isCourseFinished && (!hasUserPaid || isCourseFree) ? null : isCourseFinished ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                variant: "secondary_white",
                                                size: "medium",
                                                isFull: true,
                                                className: "px-0",
                                                children: "Download Sertifikat"
                                            }) : props.enrollment_progress?.finished === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                variant: "secondary_white",
                                                size: "medium",
                                                isFull: true,
                                                children: "Mulai Kelas"
                                            }) : props.enrollment_progress?.finished < props.enrollment_progress?.total ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex h-36 items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "text-b2",
                                                        children: [
                                                            props.enrollment_progress.finished,
                                                            " dari",
                                                            " ",
                                                            props.enrollment_progress.total
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-8"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex-1 h-8 bg-neutral-70 rounded-full overflow-hidden relative",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "rounded-full h-full bg-white",
                                                            style: {
                                                                width: props.enrollment_progress.finished / props.enrollment_progress.total * 100 + "%"
                                                            }
                                                        })
                                                    })
                                                ]
                                            }) : null
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    props.isChecked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute bg-[#0d0d0d80] top-0 rounded-8 w-full h-full p-8 flex justify-end items-start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconCheckCircle__WEBPACK_IMPORTED_MODULE_13__/* .IconCheckCircle */ .B, {})
                    }) : null,
                    isHide && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-0 bg-[#00000099] w-full h-full flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-b1 font-black text-white",
                            children: "Khusus goKampus Business"
                        })
                    })
                ]
            })
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full rounded-2 overflow-hidden",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-64 bg-neutral-20 overflow-hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        width: 160,
                        height: 64,
                        src: props.image_cover_url,
                        alt: props.name,
                        className: "h-64 w-full object-cover object-center"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-[172px] bg-purple-70 p-8 pt-0 text-white flex flex-col",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-48 h-48 rounded-2 -mt-24 bg-white p-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    width: 36,
                                    height: 36,
                                    src: props.institution?.image_url,
                                    alt: props.institution?.name,
                                    className: "object-contain object-center"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-8"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-c1 font-light line-clamp-1",
                                children: props.institution?.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-b2 font-bold line-clamp-2",
                                children: props.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-8"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-c1 font-light line-clamp-1",
                                children: [
                                    props.total_learners && !isB2B ? `${(0,lib_helper__WEBPACK_IMPORTED_MODULE_4__/* .numberWithCommas */ .x6)(props.total_learners)} pelajar | ` : null,
                                    props.duration == 0 ? null : (0,lib_date__WEBPACK_IMPORTED_MODULE_18__/* .toDuration */ .Ks)(props.duration, false)
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
};


/***/ }),

/***/ 47313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CardNotFound; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67832);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61097);
/* harmony import */ var lib_amplitude__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41272);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56562);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);






const CardNotFound = ({ useSmallIcon =false , useMaxWidth =0 , ...props })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const { title , message , useButton , src , className =""  } = props;
    const pushToTrackEvents = (label)=>{
        switch(label){
            case "Mulai Belajar Gratis":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "myclass_startlearning_a"
                });
                break;
            case "Kembali ke Homepage":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_404_back_to_homepage_a"
                });
                break;
            case "Coba Lagi":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_500_retry_a"
                });
                router.reload();
                break;
            case "Kembali":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_500_back_a"
                });
                router.back();
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `w-full flex ${useSmallIcon ? "flex-row justify-left" : "flex-col justify-center"} text-center gap-24 items-center m-auto ${className} ${useMaxWidth ? "bg-light_neutral10_to_dark_neutral50 min-h-[320px] rounded-8" : ""}`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: src ? src : "/images/icon-not-found.png",
                alt: "",
                width: useSmallIcon ? 80 : 120,
                height: useSmallIcon ? 80 : 120
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `flex flex-col gap-24 ${useMaxWidth ? `max-w-[${useMaxWidth}px] px-16 md:px-0` : ""}`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `${useSmallIcon ? "grid align-center gap-4" : "flex flex-col gap-8"}`,
                        children: [
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `text-b1 font-bold ${useSmallIcon ? "text-left" : ""}`,
                                children: title
                            }),
                            message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `text-b2 font-medium text-neutral-60 ${useSmallIcon ? "text-left" : ""}`,
                                children: message
                            })
                        ]
                    }),
                    useButton && useButton.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center " + (useButton.length > 1 ? "gap-8" : ""),
                        children: useButton.map((el)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: el.href,
                                onClick: ()=>{
                                    pushToTrackEvents(el.label);
                                    if (el.onClose) {
                                        el.onClose();
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    size: "medium",
                                    isFull: true,
                                    //@ts-ignore
                                    variant: el.variant ? el.variant : "primary",
                                    children: el.label
                                })
                            }, "useButton" + el.href))
                    }) : null
                ]
            })
        ]
    });
};


/***/ }),

/***/ 35824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ContainerDesktop; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);
/* harmony import */ var modules_Nav_BottomNav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51396);
/* harmony import */ var react_spinners__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13173);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lib_detectDeviceV2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70632);






const Container = ({ children , className ="" , wrapperClassName ="" , useNavbar =false , isLoader =false , useLoader =false  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            "bg-light_neutral10_to_dark_neutral50",
            wrapperClassName
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: [
                    "relative max-w-container mx-auto bg-white ",
                    className
                ].join(" "),
                children: [
                    children,
                    useLoader && isLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex w-full items-center justify-center h-[80vh]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spinners__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            loading: isLoader
                        })
                    })
                ]
            }),
            useNavbar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_Nav_BottomNav__WEBPACK_IMPORTED_MODULE_2__/* .BottomNav */ .L, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);
const ContainerDesktop = ({ children , className ="" , classBackgroundFull ="" , useMinHeight =false , useAuto =false , customStyle =null  })=>{
    // Device hook
    const { isMobile , isTablet , isDesktop , isPortrait , width , height  } = (0,lib_detectDeviceV2__WEBPACK_IMPORTED_MODULE_4__/* .useDeviceDetect */ .d)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `w-full ${useMinHeight ? "min-h-content" : "h-full"} ` + (classBackgroundFull ? classBackgroundFull : " bg-transparent"),
        style: customStyle != null ? customStyle : null,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            // className={`mx-auto !max-w-[1366px] w-[95%] ${
            className: `
          ${useAuto ? "mx-auto !max-w-[1366px] w-[100%] " : ""}
          ${classBackgroundFull ? "relative h-full" : ""} ${className}
          ${isDesktop ? "p-16" : ""}
        `,
            children: children ?? null
        })
    });
};


/***/ }),

/***/ 19955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);
/* harmony import */ var components_Icon_IconSearch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66317);
/* harmony import */ var lib_amplitude__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41272);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_InstantSearchBox_ModalSearchBox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32520);






const FieldSearch = ({ onChangeSearch , text , placeholder ="Ingin belajar apa hari ini?" , position ="left" , theme ="default" , handleClick , submitSearch , indexName , isShow , setModal , classWidth ="w-600 x-max:w-400"  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const themes = {
        default: "placeholder-input_placeholder bg-white text-neutral-50 ",
        white: "placeholder-white bg-[#ffffff33] text-white "
    };
    const themeIcon = {
        default: "#5D586C ",
        white: "#FFFFFF "
    };
    const themeBorder = {
        default: "border border-neutral-40 ",
        white: "border-none outline-none "
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative  " + (classWidth ?? ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute top-10 " + (position == "left" ? "left-10" : "right-10"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconSearch__WEBPACK_IMPORTED_MODULE_2__/* .IconSearch */ .j, {
                    size: 20,
                    color: themeIcon[theme]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                className: "w-full",
                onSubmit: (e)=>{
                    e.preventDefault();
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        onFocus: ()=>{
                            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEventGTM */ .hk)({
                                event: "explore_searchbar_start_a",
                                property: {
                                    page: router.pathname
                                }
                            });
                            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEventGA */ .w7)({
                                event: "explore_searchbar_start_a",
                                property: {
                                    page: router.pathname
                                }
                            });
                            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEventGTM */ .hk)({
                                event: "explore_searchbar_start_a",
                                property: {
                                    page: router.pathname
                                }
                            });
                            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEventGA */ .w7)({
                                event: "explore_searchbar_start_a",
                                property: {
                                    page: router.pathname
                                }
                            });
                            setModal(true);
                        },
                        className: `w-full focus:outline-none p-8 text-b1 font-light rounded-6 ${themes[theme]} ${themeBorder[theme]} ` + (position == "left" ? " pl-36" : " pr-36"),
                        placeholder: placeholder
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "hidden"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_InstantSearchBox_ModalSearchBox__WEBPACK_IMPORTED_MODULE_5__/* .ModalSearchBox */ .l, {
                isShow: isShow,
                setModal: setModal,
                indexName: indexName,
                onClose: ()=>{
                    setModal(false);
                    router.push({
                        pathname: "/"
                    });
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FieldSearch);


/***/ }),

/***/ 57604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InstantSearchBox_InstantSearchBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(36734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(51776);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 6 modules
var InstantSearch = __webpack_require__(31182);
// EXTERNAL MODULE: ./src/components/Icon/IconSearch.tsx
var IconSearch = __webpack_require__(66317);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/node_modules/react-instantsearch-core/dist/es/widgets/Index.js
var Index = __webpack_require__(68563);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/node_modules/react-instantsearch-core/dist/es/widgets/Configure.js + 1 modules
var Configure = __webpack_require__(86249);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/node_modules/react-instantsearch-core/dist/es/connectors/connectSearchBox.js
var connectSearchBox = __webpack_require__(31645);
// EXTERNAL MODULE: ./node_modules/react-spinners/esm/ClipLoader.js
var ClipLoader = __webpack_require__(79702);
// EXTERNAL MODULE: ./src/lib/amplitude.ts + 1 modules
var amplitude = __webpack_require__(41272);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(33906);
// EXTERNAL MODULE: ./src/lib/const.ts
var lib_const = __webpack_require__(5173);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/node_modules/react-instantsearch-core/dist/es/connectors/connectStateResults.js
var connectStateResults = __webpack_require__(53382);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(56562);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Icon/IconStar.tsx
var IconStar = __webpack_require__(28939);
// EXTERNAL MODULE: ./src/lib/helper.ts
var helper = __webpack_require__(99601);
// EXTERNAL MODULE: ./src/components/Card/CardNotFound.tsx
var CardNotFound = __webpack_require__(47313);
// EXTERNAL MODULE: ./src/modules/Auth/authStore.ts
var authStore = __webpack_require__(40474);
// EXTERNAL MODULE: ./src/components/Icon/IconPlayCircle.tsx
var IconPlayCircle = __webpack_require__(14016);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(61097);
// EXTERNAL MODULE: ./src/lib/object.ts
var object = __webpack_require__(12582);
// EXTERNAL MODULE: ./src/components/Skeleton/Skeleton.tsx
var Skeleton = __webpack_require__(9978);
// EXTERNAL MODULE: ./src/components/InstantSearchBox/searchStore.ts
var searchStore = __webpack_require__(28755);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 2 modules
var useTranslation = __webpack_require__(86880);
// EXTERNAL MODULE: ./src/lib/host.ts
var host = __webpack_require__(35304);
// EXTERNAL MODULE: ./src/lib/ssr.ts
var ssr = __webpack_require__(11927);
// EXTERNAL MODULE: ./src/modules/Tenant/homeTenantApi.ts
var homeTenantApi = __webpack_require__(97684);
// EXTERNAL MODULE: ./src/lib/algolia.ts
var algolia = __webpack_require__(96131);
// EXTERNAL MODULE: ./src/components/Image/Image.tsx + 1 modules
var Image = __webpack_require__(72317);
// EXTERNAL MODULE: ./src/modules/Home/homeStore.ts
var homeStore = __webpack_require__(88727);
;// CONCATENATED MODULE: ./src/components/InstantSearchBox/SearchHitsCourse.tsx






















function SearchHitsCourse({ searchState , searchResults , indexName , ...props }) {
    const [recommendCourses, setRecommendCourses] = (0,react.useState)([]);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [allCourses, setAllCourses] = (0,react.useState)(null);
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const isB2B = (0,host/* useIsTenant */.we)() || (0,host/* useIsSubdomain */.Do)();
    const loginState = (0,authStore/* useAuthStore */.t)((state)=>state.loginState);
    const { setRecommendData  } = (0,searchStore/* useSearchStore */.R)();
    const router = (0,next_router.useRouter)();
    /// Access Courses List
    const getCourses = (0,homeTenantApi/* useGetCoursesByTenantSlug */.HL)();
    const currentUser = (0,authStore/* useAuthStore */.t)((state)=>state.currentUser);
    const { setDataCourseId  } = (0,homeStore/* useHomeStore */.o)();
    // checking if the query length is >= 3
    // (since 3 is the minimum Algolia query length)
    const validQuery = searchState.query?.length >= 3;
    const totalData = searchResults?.nbHits;
    const dataCourses = searchResults?.hits.length > 0 && searchState.query && validQuery ? searchResults.hits : searchResults?.hits.length > 0 && !searchState.query ? searchResults.hits : null;
    let seeAllBtn = null;
    let searchResultsLms = null;
    if (props.showBtn) {
        seeAllBtn = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "secondary",
            size: "medium",
            isFull: true,
            className: "px-16 py-8 mt-12",
            onClick: props.onClickEnter,
            children: "Lihat semua"
        });
        searchResultsLms = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center text-b1 font-light text-neutral-60",
            children: [
                totalData > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: totalData
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mx-4",
                    children: "Hasil Pencarian untuk"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "font-medium text-neutral-80",
                    children: [
                        '"',
                        props.searchValue,
                        '"'
                    ]
                })
            ]
        });
    }
    const { forbiddenCourses  } = (0,homeStore/* useHomeStore */.o)();
    const getCourseRecommend = ()=>{
        const subDomain = (0,ssr/* isBrowser */.j)() ? (0,host/* getSubDomain */.ZC)(window.location.hostname) : null;
        const computeIndexName = ()=>{
            if (currentUser) {
                if (currentUser.referral.includes("gaji-c")) {
                    return currentUser.referral !== "gaji-c0000117" ? (0,algolia/* generateIndexName */.AP)("gaji") : (0,algolia/* generateIndexName */.AP)(currentUser.referral);
                }
                return (0,algolia/* generateIndexName */.AP)(window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : window.location.hostname === "lms.injourney.id" ? "injourney" : currentUser.referral === "bssn" ? "tapinkab" : currentUser.referral);
            }
            return (0,algolia/* generateIndexName */.AP)(window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : window.location.hostname === "lms.injourney.id" ? "injourney" : subDomain === "bssn" ? "tapinkab" : subDomain);
        };
        const indexName = computeIndexName();
        setAllCourses(null);
        setIsLoading(true);
        const referral = isB2B ? currentUser?.referral ?? subDomain : currentUser?.referral;
        if (referral && ![
            "moodle",
            "example"
        ].includes(referral)) {
            fetch(referral ? searchState.query ? `/api/search-algolia?indexName=${indexName}&q=${searchState.query}` : `/api/search-algolia?indexName=${indexName}` : "/api/search").then((res)=>res.json()).then((res)=>{
                const data = (0,object/* ArrayObjectSortBy */.Jy)(res.data?.hits, "created_date", true) ?? [];
                const recommendCourses = data.slice(0, 4);
                const filtered = recommendCourses.filter((a)=>!forbiddenCourses.includes(a.slug));
                setRecommendCourses(filtered);
                const topOneCourseSlug = recommendCourses.slice(0, 1).map((course)=>course.slug);
                setDataCourseId(topOneCourseSlug);
                if (recommendCourses.length) {
                    setRecommendData(filtered);
                }
                setTimeout(()=>{
                    setIsLoading(false);
                }, 500);
            });
        }
    };
    const referralCode = (0,helper/* getCookie */.ej)("ref_code_gk") && (0,helper/* getCookie */.ej)("ref_code_gk") !== "null" ? (0,helper/* getCookie */.ej)("ref_code_gk") :  true ? new URLSearchParams(window.location.search).get("referral") : 0;
    (0,react.useEffect)(()=>{
        if (!searchState.query) {
            setAllCourses(null);
            setIsLoading(true);
            const subDomain = (0,ssr/* isBrowser */.j)() ? (0,host/* getSubDomain */.ZC)(window.location.hostname) : null;
            const referral = isB2B ? currentUser?.referral ?? subDomain : currentUser?.referral;
            if (referral && ![
                "moodle",
                "example"
            ].includes(referral)) {
                getCourses.doFetch({
                    slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : window.location.hostname === "lms.injourney.id" ? "injourney" : // ? referralCode
                    referral,
                    // @ts-ignore
                    popular: 1
                }, {
                    onSuccess (data) {
                        const filtered = data?.data.filter((a)=>!forbiddenCourses.includes(a.slug));
                        // Get first 3 courses
                        setAllCourses(filtered.slice(0, 3));
                        setIsLoading(false);
                    }
                });
            }
            return;
        }
        if (dataCourses && dataCourses.length > 0) {
            const newData = isB2B ? loginState === "LOGIN" ? dataCourses : dataCourses.filter((a)=>!a.tenant) : dataCourses.filter((a)=>!a.is_institution_business);
            const topOneCourseSlug = newData.slice(0, 1).map((course)=>course.slug);
            setDataCourseId(topOneCourseSlug);
            const filtered = newData.filter((a)=>!forbiddenCourses.includes(a.slug));
            // Anonymous user (tidak ada referral)
            if (!currentUser?.referral) {
                if (newData.length > 0) {
                    setAllCourses(filtered);
                } else {
                    getCourseRecommend();
                }
                return;
            }
            // Logged-in user with referral: filter pakai forbiddenCourses
            if (Array.isArray(forbiddenCourses) && forbiddenCourses.length > 0) {
                const showedCourses = newData.filter((course)=>!forbiddenCourses.includes(course.slug));
                setAllCourses(showedCourses);
            } else {
                if (newData.length > 0) {
                    setAllCourses(filtered);
                } else {
                    getCourseRecommend();
                }
            }
        } else {
            getCourseRecommend();
        }
    }, [
        searchState.query
    ]);
    (0,react.useEffect)(()=>{
        if (searchState.query) {
            (0,amplitude/* trackEvent */.L9)({
                event: "explore_searchbar_suggestion_a",
                property: {
                    page: router.pathname,
                    query: searchState.query
                }
            });
        }
    }, [
        searchResults?.hits
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !allCourses || allCourses.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-24",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid gap-12 hg-max:max-h-[50vh] hg-max:overflow-y-scroll",
                children: [
                    !isLoading && recommendCourses.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotFound/* CardNotFound */._, {
                        title: "Kursus Tidak Ditemukan",
                        message: "Coba cari kursus dengan kata kunci lain",
                        className: "!gap-16 bg-slated_grey2 rounded-8",
                        useSmallIcon: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-b1 font-medium text-neutral-80",
                        children: t("recommendationForYou")
                    }),
                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-12",
                            children: [
                                1,
                                2,
                                3,
                                4
                            ].map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row gap-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                            className: "h-80 w-140 rounded-8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col justify-center items-center w-[calc(100%-148px)] gap-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                                    className: "h-16 w-full"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                                    className: "h-16 w-full"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                                    className: "h-16 w-full"
                                                })
                                            ]
                                        })
                                    ]
                                }, el + Math.random()))
                        })
                    }) : recommendCourses && recommendCourses.map((hit, index)=>// @ts-ignore
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCourse, {
                            ...hit,
                            index,
                            closeModal: props.closeModal,
                            query: searchState.query ?? ""
                        }, Math.random() + "--" + hit.id))
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                searchResultsLms,
                !searchState.query && allCourses.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-medium text-neutral-80 text-b1 mt-16 md:mt-0",
                    children: t("popularCourses")
                }),
                allCourses.map((hit, index)=>// @ts-ignore
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCourse, {
                        ...hit,
                        index,
                        closeModal: props.closeModal,
                        query: searchState.query ?? ""
                    }, Math.random() + "-" + hit.id)),
                seeAllBtn
            ]
        })
    });
}
/* harmony default export */ var InstantSearchBox_SearchHitsCourse = ((0,connectStateResults/* default */.Z)(SearchHitsCourse));
function ItemCourse({ ...props }) {
    const loginState = (0,authStore/* useAuthStore */.t)((state)=>state.loginState);
    const router = (0,next_router.useRouter)();
    const closeModal = ()=>props.closeModal ? props.closeModal() : null;
    const isLMS = router.pathname.includes("/course/[courseSlug]");
    const isB2B = (0,host/* useIsTenant */.we)() || (0,host/* useIsSubdomain */.Do)();
    const institutionName = props?.institution?.name ?? props?.institution?.split("||")[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        onClick: ()=>{
            (0,amplitude/* trackEvent */.L9)({
                event: "explore_searchbar_suggestion_course_a",
                property: {
                    page: router.pathname,
                    course_name: props.name,
                    course_slug: props.slug,
                    institution_name: props.institution.split("||")[0] || "",
                    index: props.index,
                    query: props.query
                }
            });
            closeModal();
        },
        href: loginState == "LOGIN" && isLMS ? {
            pathname: "/r/[page]",
            query: {
                page: `/course/${props?.slug}`
            }
        } : loginState == "LOGIN" ? {
            pathname: "/course/[courseSlug]",
            query: {
                courseSlug: props?.slug
            }
        } : {
            pathname: "/login",
            query: {
                url: encodeURIComponent(`/course/${props?.slug}`)
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row w-full gap-8 cursor-pointer",
            children: [
                props?.image_cover_url ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "h-80 w-[140px] relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image.Image, {
                            alt: props?.name,
                            src: props?.image_cover_url,
                            className: "object-cover object-center rounded-8",
                            width: 140,
                            height: 80
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute rounded-8 w-[140px] h-80 top-0 flex justify-center items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPlayCircle/* IconPlayCircle */.U, {
                                size: 32,
                                classes: "m-auto",
                                isBgCustomized: true
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-140 h-80 rounded-8 bg-neutral-20"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid w-[calc(100%-148px)] justify-start gap-4 text-b2 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-light line-clamp-1",
                            children: institutionName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-neutral-80 font-medium line-clamp-1",
                            children: props?.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-8 justify-start items-center text-c1 font-light",
                            children: [
                                typeof props?.review_summary?.star_avg === "number" && props?.review_summary?.star_avg !== 0 && !isB2B ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStar/* IconStar */.G, {
                                                    size: 12,
                                                    fill: true,
                                                    color: "#EFB443"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ml-2 text-c1",
                                                    children: (0,helper/* formatRating */.A6)(//  @ts-ignore
                                                    props?.review_summary?.star_avg.toFixed(1))
                                                })
                                            ]
                                        }),
                                        "|"
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                props?.total_learners !== 0 && !isB2B && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: `${(0,helper/* numberWithCommas */.x6)(props?.total_learners)} pelajar`
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/PageHeader/BackButton.tsx
var BackButton = __webpack_require__(1452);
// EXTERNAL MODULE: ./src/components/ModalPortal/Modal.tsx + 1 modules
var Modal = __webpack_require__(54642);
// EXTERNAL MODULE: ./src/components/Card/CardCourse.legacy.tsx
var CardCourse_legacy = __webpack_require__(36538);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(35824);
// EXTERNAL MODULE: ./src/components/Icon/IconClose.tsx
var IconClose = __webpack_require__(84132);
;// CONCATENATED MODULE: ./src/components/InstantSearchBox/SearchResultsLms.tsx












function SearchResultsLms({ searchState , searchResults , ...props }) {
    // checking if the query length is >= 3
    // (since 3 is the minimum Algolia query length)
    const validQuery = searchState.query?.length >= 3;
    const loginState = (0,authStore/* useAuthStore */.t)((state)=>state.loginState);
    const totalData = searchResults?.nbHits;
    const router = (0,next_router.useRouter)();
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [allCourses, setAllCourses] = (0,react.useState)(null);
    const isB2B = (0,host/* useIsTenant */.we)() || (0,host/* useIsSubdomain */.Do)();
    const dataCourses = searchResults?.hits.length > 0 && searchState.query && validQuery ? searchResults.hits : searchResults?.hits.length > 0 && !searchState.query ? searchResults.hits : null;
    (0,react.useEffect)(()=>{
        if (dataCourses && dataCourses.length > 0) {
            const newData = isB2B ? dataCourses : dataCourses.filter((a)=>!a.is_institution_business);
            if (newData && newData.length > 0) {
                setAllCourses(newData);
            } else {
                setAllCourses(null);
            }
        } else {
            setAllCourses(null);
        }
    }, [
        dataCourses
    ]);
    const searchResultsTitle = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center py-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: props.closeModal,
                className: "text-neutral-80 mr-16 cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                    size: 20
                })
            }),
            props.searchValue && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center text-b1 font-medium text-neutral-60",
                children: [
                    allCourses && allCourses.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: allCourses.length
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mx-4",
                        children: "Hasil Pencarian untuk"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-neutral-80",
                        children: [
                            '"',
                            props.searchValue,
                            '"'
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute top-[71px] w-full bg-white rounded-b-16",
        children: !allCourses ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* ContainerDesktop */.h, {
            children: [
                searchResultsTitle,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotFound/* CardNotFound */._, {
                    title: "Kursus Tidak Ditemukan",
                    message: "Coba cari kursus dengan kata kunci lain",
                    className: "!gap-16 pb-24"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* ContainerDesktop */.h, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        searchResultsTitle,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            onClick: ()=>{
                                (0,amplitude/* trackEvent */.L9)({
                                    event: "explore_searchbar_srp_course_more_a",
                                    property: {
                                        page: router.pathname,
                                        query: props.searchValue
                                    }
                                });
                                props.onClickEnter();
                            },
                            className: "pr-16 text-violet_main_to_dark_purple_surface text-b1 font-medium cursor-pointer",
                            children: "Lihat Semua Hasil"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-4 gap-8 pb-24",
                    children: allCourses.map((hit, index)=>// @ts-ignore
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: loginState == "LOGIN" ? {
                                pathname: "/r/[page]",
                                query: {
                                    page: `/course/${hit?.slug}`
                                }
                            } : {
                                pathname: "/login",
                                query: {
                                    url: encodeURIComponent(`/course/${hit?.slug}`)
                                }
                            },
                            onClick: ()=>{
                                (0,amplitude/* trackEvent */.L9)({
                                    event: "explore_searchbar_srp_course_a",
                                    property: {
                                        page: router.pathname,
                                        query: props.searchValue,
                                        course_name: hit.name,
                                        course_slug: hit.slug,
                                        institution_name: hit?.institution?.split("||")[0],
                                        index
                                    }
                                });
                                props.closeModal();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCourse_legacy/* CardCourse */._, {
                                ...hit,
                                index,
                                isLayoutNew: true,
                                isHorizontal: true,
                                className: "card-default"
                            }, hit.id)
                        }))
                })
            ]
        })
    });
}
/* harmony default export */ var InstantSearchBox_SearchResultsLms = ((0,connectStateResults/* default */.Z)(SearchResultsLms));

// EXTERNAL MODULE: ./src/components/PageHeader/systemStore.ts
var systemStore = __webpack_require__(96937);
;// CONCATENATED MODULE: ./src/components/InstantSearchBox/SearchBox.tsx

















const useOutsideClick = (callback)=>{
    const ref = react.useRef();
    react.useEffect(()=>{
        const handleClick = (event)=>{
            if (ref.current && !ref.current?.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener("click", handleClick, true);
        return ()=>{
            document.removeEventListener("click", handleClick, true);
        };
    }, [
        ref
    ]);
    return ref;
};
function SearchBox({ currentRefinement , refine , className , indexName , ...props }) {
    const router = (0,next_router.useRouter)();
    const query = router && router.query.q || null;
    const [theme] = (0,systemStore/* useSystemStore */.m)((state)=>[
            state.theme
        ]);
    /// read value from path param of q
    const [value, setValue] = (0,react.useState)(currentRefinement || query);
    const [timeout, setTime] = (0,react.useState)(null);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const isDesktop =  true && window.innerWidth > 720;
    const [show, setShow] = (0,react.useState)(false);
    const [showLms, setLms] = (0,react.useState)(false);
    const [showBtn, setShowBtn] = (0,react.useState)(false);
    const isLMS = router.pathname.includes("/course/[courseSlug]");
    const isB2B = (0,host/* useIsTenant */.we)() || (0,host/* useIsSubdomain */.Do)();
    const tagsKey = router.query.tagsKey ?? "";
    const institutionKey = router.query.institutionKey ?? "";
    const q = router?.query?.q ?? "";
    const institutionNames = typeof router.query.institutionKey == "string" && router.query.institutionKey ? router.query.institutionKey.split(",") : [];
    const institutionKeyFilter = institutionNames.length ? `${institutionNames.map((ins)=>`institution:"${ins}"`).join(" OR ")}` : "";
    const tagsNames = typeof router.query.tagsKey == "string" && router.query.tagsKey ? router.query.tagsKey.split(",") : [];
    const tagsKeyFilter = tagsNames.length ? `${tagsNames.map((ins)=>`tags:"${ins}"`).join(" OR ")}` : "";
    const isEnteredSearch = tagsKeyFilter !== "" || institutionKeyFilter !== "";
    const isAnyFiltered = q !== "";
    const { dataCourseId  } = (0,homeStore/* useHomeStore */.o)();
    const handleReset = ()=>{
        setValue("");
        router.push({
            pathname: "/"
        });
    };
    const themes = {
        default: "placeholder-input_placeholder bg-white text-neutral-50 ",
        white: "placeholder-white bg-[#ffffff33] text-white ",
        transparent: "placeholder-input_placeholder bg-transparent text-neutral-50 "
    };
    const themeIcon = {
        default: "#5D586C ",
        white: "#FFFFFF ",
        transparent: "#44199A"
    };
    (0,react.useEffect)(()=>{
        if (!q) {
            setValue("");
        }
    }, [
        q
    ]);
    const ref = useOutsideClick(()=>{
        setShow(false);
    });
    const onChangeDebounced = (event)=>{
        const value = event.currentTarget.value;
        // if (value === "") {
        //   setShow(false);
        //   setLms(false);
        //   setShowBtn(false);
        // }
        timeout && clearTimeout(timeout);
        if (value) {
            setIsLoading(true);
        } else {
        // only push route for desktop view
        // No need to change path since this makes
        // LMS page move to homepage when activated (23/7/24)
        // if (isB2B && window.screen.availWidth > 900) {
        //   router.push({
        //     pathname: "/",
        //   });
        // }
        }
        setTime(setTimeout(()=>{
            refine(value);
            setIsLoading(false);
        }, 1000));
        /// No need to redirect since algolia already return
        /// recommendation after delete the form in search box
        // if(isB2B && !value && isDesktop && !isLMS) {
        //   router.push({
        //     pathname: "/",
        //   });
        // }
        setValue(value);
    };
    (0,react.useEffect)(()=>{
        if (props.focus) {
            setShow(true);
        }
    }, [
        props
    ]);
    const toExplorePage = ()=>{
        router.push({
            pathname: "/explore/search",
            query: {
                q: value
            }
        });
        setShow(false);
    };
    const toHomeTenantPage = ()=>{
        router.push({
            pathname: "/",
            query: {
                ...router.query,
                ...value && {
                    q: value
                }
            }
        });
        setShow(false);
    };
    const handleKeyPress = (event)=>{
        if ((event.charCode == 13 || event.key == "Enter") && event.target.value !== "") {
            event.preventDefault();
            (0,amplitude/* trackEventGTM */.hk)({
                event: "explore_searchbar_a",
                property: {
                    query: value,
                    search_slug: dataCourseId,
                    page: router.pathname
                }
            });
            (0,amplitude/* trackEventGA */.w7)({
                event: "explore_searchbar_a",
                property: {
                    query: value,
                    search_slug: dataCourseId,
                    page: router.pathname
                }
            });
            if (isDesktop && isLMS) {
                event.target.blur();
                setShow(false);
                /// Directly redirect user to search page
                /// Instead of showing popup result 4 recommendation courses
                // setLms(true);
                if (isB2B) {
                    toHomeTenantPage();
                } else {
                    toExplorePage();
                }
                return;
            }
            if (isLMS && !isDesktop) {
                event.target.blur();
                /// Directly redirect user to search page
                /// Instead of showing popup result 4 recommendation courses
                // setShowBtn(true);
                if (isB2B) {
                    toHomeTenantPage();
                } else {
                    toExplorePage();
                }
                return;
            }
            if (isB2B) {
                toHomeTenantPage();
            } else {
                toExplorePage();
            }
        }
    };
    const renderResult = ()=>{
        let courseSuggestions = 3;
        if (showBtn) courseSuggestions = 4;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: `${props.contentClass ?? ""} z-50 md:bg-slated_grey p-16 grid gap-12 rounded-12 shadow-dropdown absolute pointer-events-auto z-200 w-full h-fit top-50 `,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Index/* default */.Z, {
                indexName: indexName ?? lib_const/* CONST.ALGOLIA_SEARCH_INDEX */.o.ALGOLIA_SEARCH_INDEX,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                        hitsPerPage: courseSuggestions
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearchBox_SearchHitsCourse, {
                        searchValue: value,
                        showBtn: showBtn,
                        onClickEnter: isB2B ? toHomeTenantPage : toExplorePage,
                        closeModal: props.onBackHeader,
                        indexName: indexName
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex gap-12 items-center",
        ref: ref,
        children: [
            props.onBackHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* BackButton */.x, {
                backTo: ()=>props.onBackHeader()
            }),
            props.position == "left" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // className={`absolute right-0 flex items-center bg-white_to_dark20 ${
                //   props.onBackHeader ? "left-48 z-20 mr-2" : "left-10 z-10"
                // }`}
                className: `absolute top-10 ${props.onBackHeader ? "left-48 z-20 mr-2" : "left-10 z-10"}`,
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipLoader/* default */.Z, {
                    size: 16,
                    color: "black"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: isAnyFiltered ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: handleReset,
                        className: "cursor-pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                            size: 20,
                            color: "#883CFF"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSearch/* IconSearch */.j, {
                        size: 20,
                        color: theme === "dark" ? "#C29FEE" : "#883CFF"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: `${className} ${props.position == "left" ? props.onBackHeader ? "pl-40" : "pl-32" : ""} relative h-40 p-[7px] text-b1 font-light border border-neutral40_to_dark20 rounded-100 ${themes[props.theme ?? "default"]} focus:outline focus:outline-2 focus:outline-purple-50 text-ellipsis ml-12`,
                placeholder: props?.placeholder ?? "Search...",
                onChange: (e)=>{
                    onChangeDebounced(e);
                },
                onKeyPress: handleKeyPress,
                onFocus: ()=>{
                    (0,amplitude/* trackEventGTM */.hk)({
                        event: "explore_searchbar_start_a",
                        property: {
                            page: router.pathname
                        }
                    });
                    (0,amplitude/* trackEventGA */.w7)({
                        event: "explore_searchbar_start_a",
                        property: {
                            page: router.pathname
                        }
                    });
                    setShow(true);
                    setLms(false);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter") {
                        props?.setModal && props.setModal(false);
                        router.push({
                            pathname: "/",
                            query: {
                                q: value
                            }
                        });
                    }
                },
                value: value,
                autoFocus: props.focus ?? false
            }),
            props?.position == "right" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // className={"absolute top-10 right-10"}
                className: "absolute right-0 flex items-center bg-light_neutral10_to_dark_neutral50 border border-neutral40_to_dark20",
                style: {
                    height: "100%",
                    padding: "10px",
                    borderTopRightRadius: "100px",
                    borderBottomRightRadius: "100px"
                },
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipLoader/* default */.Z, {
                    size: 16,
                    color: "fill-neutral-50"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: isAnyFiltered ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: handleReset,
                        className: "cursor-pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                            size: 20,
                            color: theme === "dark" ? "#C29FEE" : "#883CFF"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSearch/* IconSearch */.j, {
                        size: 20,
                        color: theme === "dark" ? "#C29FEE" : "#883CFF"
                    })
                })
            }),
            show && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: renderResult()
            }),
            showLms && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                isFull: true,
                closeModal: ()=>setLms(false),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Index/* default */.Z, {
                    indexName: indexName ?? lib_const/* CONST.ALGOLIA_SEARCH_INDEX */.o.ALGOLIA_SEARCH_INDEX,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                            hitsPerPage: 4
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearchBox_SearchResultsLms, {
                            searchValue: value,
                            onClickEnter: isB2B ? toHomeTenantPage : toExplorePage,
                            closeModal: ()=>setLms(false)
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var InstantSearchBox_SearchBox = ((0,connectSearchBox/* default */.Z)(SearchBox));

// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch.umd.js
var algoliasearch_umd = __webpack_require__(44260);
var algoliasearch_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_umd);
;// CONCATENATED MODULE: ./src/components/InstantSearchBox/InstantSearchBox.tsx






const searchClient = algoliasearch_umd_default()(lib_const/* CONST.ALGOLIA_APP_ID */.o.ALGOLIA_APP_ID, lib_const/* CONST.ALGOLIA_SEARCH_KEY */.o.ALGOLIA_SEARCH_KEY);
const InstantSearchBox = ({ indexName , ...props })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearch/* default */.Z, {
            searchClient: searchClient,
            indexName: indexName ?? lib_const/* CONST.ALGOLIA_SEARCH_INDEX */.o.ALGOLIA_SEARCH_INDEX,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid gap-8 relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearchBox_SearchBox, {
                    ...props,
                    indexName: indexName,
                    className: props.className ?? ""
                })
            })
        })
    });
};
/* harmony default export */ var InstantSearchBox_InstantSearchBox = (InstantSearchBox);


/***/ }),

/***/ 32520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ ModalSearchBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var components_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59177);
/* harmony import */ var _InstantSearchBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57604);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86880);
/* harmony import */ var lib_host__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35304);






const ModalSearchBox = ({ isShow , setModal , onClose , title , indexName , ...props })=>{
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("common");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        // zIndex={10}
        // isSearch={isShow}
        isShow: isShow,
        contentClassName: "!rounded-0",
        className: "!bottom-auto",
        isWidthScreen: "100vw",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full h-screen",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InstantSearchBox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                indexName: indexName,
                placeholder: (0,lib_host__WEBPACK_IMPORTED_MODULE_5__/* .useIsTenant */ .we)() ? t("searchCoursesTruncate") : t("searchCourses"),
                position: "left",
                className: "w-full",
                contentClass: "!shadow-none !p-0 h-fit",
                focus: isShow,
                setModal: setModal,
                events: {
                    event: "explore_searchbar_a",
                    property: {
                        page: router.pathname
                    }
                },
                onBackHeader: onClose
            })
        })
    });
};


/***/ }),

/***/ 28755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useSearchStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79010);

const useSearchStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        // state
        currentRecommend: [],
        totalFilter: 0,
        popularCourse: [],
        searches: [],
        keywords: [],
        indexName: "",
        // actions
        setRecommendData (item) {
            set({
                currentRecommend: item
            });
        },
        setTotalFilter (filter) {
            set({
                totalFilter: filter
            });
        },
        setPopularCourse (item) {
            set({
                popularCourse: item
            });
        },
        setSearches (item) {
            set({
                searches: item
            });
        },
        setKeywords (item) {
            set({
                keywords: item
            });
        },
        setIndexName (item) {
            set({
                indexName: item
            });
        }
    }));


/***/ }),

/***/ 54642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ModalPortal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(36734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(51776);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(70257);
;// CONCATENATED MODULE: ./src/components/ModalPortal/ModalPortal.tsx


const ModalPortal = ({ children  })=>{
    const [mounted, setMounted] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setMounted(true);
        return ()=>{
            setMounted(false);
        };
    }, []);
    if (typeof document === "undefined" || !mounted) return null;
    const modalRoot = document.getElementById("modal");
    return /*#__PURE__*/ react_dom.createPortal(children, modalRoot);
};
/* harmony default export */ var ModalPortal_ModalPortal = (ModalPortal);

;// CONCATENATED MODULE: ./src/components/ModalPortal/Modal.tsx


const Modal = ({ children , closeModal , show =true , isCenter =false , isBottom =false , zIdx =0 , isFull =false , hide =false , top ="0"  })=>{
    if (!show) return null;
    const modal_style = {
        position: "fixed",
        transform: "translate(-50%, -50%)",
        top: "50%",
        left: "50%",
        zIndex: 1001
    };
    const modal_style_bottom = {
        position: "fixed",
        transform: "translateX(-50%)",
        bottom: "0",
        left: "50%",
        zIndex: 1001
    };
    const modal_style_top = {
        position: "fixed",
        transform: "translateX(-50%)",
        top,
        left: "50%",
        zIndex: 1001
    };
    const overlay = {
        zIndex: zIdx
    };
    const style = "w-full";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPortal_ModalPortal, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: closeModal,
                    style: overlay,
                    className: `bg-black opacity-40 top-0 bottom-0 right-0 left-0 fixed ${hide ? "hidden" : ""}`
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: isCenter ? modal_style : isBottom ? modal_style_bottom : modal_style_top,
                    className: `${isFull ? style : ""} ${hide ? "hidden" : ""}`,
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var ModalPortal_Modal = (Modal);


/***/ }),

/***/ 59647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ks": function() { return /* binding */ toDuration; },
/* harmony export */   "ZB": function() { return /* binding */ toTime; },
/* harmony export */   "aY": function() { return /* binding */ toDDMMYYYY; },
/* harmony export */   "hk": function() { return /* binding */ toDDMMYYYYHHMM; }
/* harmony export */ });
const toDDMMYYYY = (str, format)=>{
    try {
        str = str.endsWith("Z") ? str : str + "Z";
        const date = new Date(str);
        return date.toLocaleDateString("id", {
            year: "numeric",
            month: format ? format : "long",
            day: "numeric"
        });
    } catch (err) {
        return "";
    }
};
const toDDMMYYYYHHMM = (str, format, useComma, useWeekdays)=>{
    try {
        let comma = useComma == false ? useComma : true;
        str = str.endsWith("Z") ? str : str + "Z";
        const date = new Date(str);
        let objectDate = {
            year: "numeric",
            month: format ? format : "short",
            day: "numeric"
        };
        if (useWeekdays) {
            //@ts-ignore
            objectDate.weekday = "long";
        }
        return(//@ts-ignore
        date.toLocaleDateString("id", objectDate) + (comma ? ", " : " ") + date.toLocaleTimeString("id", {
            hour: "2-digit",
            minute: "2-digit"
        }));
    } catch (err) {
        return "";
    }
};
const toDuration = (minute, isShort = true)=>{
    const minuteString = isShort ? "m" : " menit";
    const hourString = isShort ? "j" : " jam";
    let y = minute % 3600;
    let hours = Math.floor(minute / 60);
    let minutes = y / 60;
    let seconds = y % 60;
    if (minute < 60) {
        return minute + minuteString;
    }
    if (!isShort) {
        return `${hours !== 0 ? `${hours} jam ${Math.floor(minutes)} menit` : `${minute} menit`} ${Math.floor(seconds)} detik`;
    } else {
        return Math.floor(minute / 60) + hourString + minute ? " " + minute + minuteString : "";
    }
};
const toTime = (second)=>{
    const secondInt = ~~second;
    const pad = (n)=>n < 10 ? `0${n}` : `${n}`;
    if (secondInt >= 3600) {
        return `${~~(secondInt / 3600)}:${pad(~~(~~(secondInt % 3600) / 60))}:${pad(secondInt % 60)}`;
    } else if (secondInt >= 60) {
        return `${~~(secondInt / 60)}:${pad(secondInt % 60)}`;
    } else {
        return `0:${pad(secondInt)}`;
    }
};


/***/ })

}]);